<template>
  <div>
    <AllReceivedSendOuts :selectedStatuses="statuses"></AllReceivedSendOuts>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllReceivedSendOuts = defineAsyncComponent(() =>
  import("@/components/sendOuts/AllReceivedSendOuts")
);
export default {
  components: {
    AllReceivedSendOuts,
  },
  data() {
    return {
      statuses: ["ACTIVE"],
    };
  },
};
</script>
